import compose from 'recompose/compose';
import { connect } from 'react-redux';
import lifecycle from 'recompose/lifecycle';
import Cookies from 'js-cookie';
import withHandlers from 'recompose/withHandlers';
import preventRenderForKioskMode from '../../hoc/preventRenderForKioskMode';
import preventRenderForEmbeddedMode from '../../hoc/preventRenderForEmbeddedMode';
import preventRenderForWebNotifications from '../../hoc/preventRenderForWebNotifications';
import { setAcceptCookie } from '../actions';
import { COOKIE } from '../constants';

const AcceptCookiesContainer = compose(
  preventRenderForEmbeddedMode,
  preventRenderForKioskMode,
  preventRenderForWebNotifications,
  connect(null, { setAcceptCookie }),
  lifecycle({
    componentDidMount() {
      this.props.setAcceptCookie(Cookies.get(COOKIE));
    },
  }),
  withHandlers({
    onAccept: props => () => {
      props.setAcceptCookie(true);
    },
  }),
);

export default AcceptCookiesContainer;



// WEBPACK FOOTER //
// ./src/app/acceptCookies/containers/AcceptCookies.js